module.exports = __webpack_public_path__ + "img/timeline-13.d95242fd.svg";